import { addMinutes, differenceInMinutes } from 'date-fns';

type ResourceScheduleRoundingMode = 'floor' | 'round' | 'ceil';

function applyResourceScheduleRounding(value: number, rounding: ResourceScheduleRoundingMode): number {
  switch (rounding) {
    case 'floor':
      return Math.floor(value);
    case 'ceil':
      return Math.ceil(value);
    default:
      return Math.round(value);
  }
}

export function getResourceScheduleDateForSlotIndex(
  timelineStart: Date,
  slotIndex: number,
  intervalMinutes: number,
): Date {
  return addMinutes(timelineStart, slotIndex * intervalMinutes);
}

export function getResourceScheduleSlotIndexForDate(
  date: Date,
  timelineStart: Date,
  intervalMinutes: number,
  rounding: ResourceScheduleRoundingMode = 'round',
): number {
  const rawIndex = differenceInMinutes(date, timelineStart) / intervalMinutes;
  return applyResourceScheduleRounding(rawIndex, rounding);
}

export function getResourceScheduleDurationSlotsFromDates(
  start: Date,
  end: Date,
  intervalMinutes: number,
  rounding: ResourceScheduleRoundingMode = 'round',
  minimumSlots: number = 1,
): number {
  const rawSlots = differenceInMinutes(end, start) / intervalMinutes;
  return Math.max(minimumSlots, applyResourceScheduleRounding(rawSlots, rounding));
}

export function clampResourceScheduleMoveSlotIndex(
  startSlotIndex: number,
  deltaSlots: number,
  visibleSlotCount: number,
  durationSlots: number,
): number {
  const maxStartSlotIndex = Math.max(0, visibleSlotCount - durationSlots);
  return Math.max(0, Math.min(maxStartSlotIndex, startSlotIndex + deltaSlots));
}